import { Component, inject, input, output } from '@angular/core';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';
import { TranslateService } from '@ngx-translate/core';
import { CiscoTile, CiscoTileState } from '../tiles.model';

interface TileClickEvent {
  tileState: CiscoTileState;
  index: number;
}

@Component({
  selector: 'ziro-user-detail-home-service-tile',
  templateUrl: './user-detail-home-service-tile.component.html',
  standalone: false,
})
export class ZiroUserDetailHomeServiceTileComponent {
  private translateService = inject(TranslateService);

  readonly tileStates = input<CiscoTileState[]>();

  readonly addTileClicked = output<TileClickEvent>();
  readonly editTileClicked = output<TileClickEvent>();
  readonly editTileDeleteClicked = output<TileClickEvent>();
  readonly deleteTileConfirmButtonClicked = output<TileClickEvent>();
  readonly deleteTileCancelButtonClicked = output<TileClickEvent>();
  readonly copyDeskphoneButtonClicked = output<TileClickEvent>();

  ziroIcons = ZiroIcons;
  tiles = CiscoTile;

  onAddTileClicked(tileState: CiscoTileState, index: number): void {
    this.addTileClicked.emit({ tileState, index });
  }

  onEditTileClicked(tileState: CiscoTileState, index: number): void {
    this.editTileClicked.emit({ tileState, index });
  }

  onEditTileDeleteClicked(tileState: CiscoTileState, index: number): void {
    this.editTileDeleteClicked.emit({ tileState, index });
  }

  onDeleteTileConfirmButtonClicked(tileState: CiscoTileState, index: number): void {
    this.deleteTileConfirmButtonClicked.emit({ tileState, index });
  }

  onDeleteTileCancelButtonClicked(tileState: CiscoTileState, index: number): void {
    this.deleteTileCancelButtonClicked.emit({ tileState, index });
  }

  getMultiTileDescription(tileState: CiscoTileState, count: number): string {
    return `${this.translateService.instant(this.getMultiTileDescriptionKey(tileState))} (${count})`;
  }

  getMultiTileDescriptionKey(tileState: CiscoTileState): string {
    switch (tileState.serviceType) {
      case CiscoTile.TABLET: {
        return 'tkey;shared.model.tablet.text';
      }
      case CiscoTile.IM_SOFTPHONE: {
        return 'tkey;shared.model.imsoftphone.text';
      }
      case CiscoTile.CIPC: {
        return 'tkey;shared.model.cipc.text';
      }
      case CiscoTile.ANDROID: {
        return 'tkey;shared.model.android.text';
      }
      case CiscoTile.IPHONE: {
        return 'tkey;shared.model.iphone.text';
      }
      case CiscoTile.DESKPHONE: {
        return 'tkey;shared.model.deskphone.text';
      }
      case CiscoTile.CTI_PORT: {
        return 'tkey;shared.model.ctiport.text';
      }
      case CiscoTile.CTI_REMOTE_DEVICE: {
        return 'tkey;shared.model.ctiremotedevice.text';
      }
      case CiscoTile.SPARK_REMOTE_DEVICE: {
        return 'tkey;shared.model.sparkremotedevice.text';
      }
      default: {
        break;
      }
    }
  }

  onCopyDeskphoneClicked(tileState: CiscoTileState, index: number): void {
    if (tileState.serviceType === CiscoTile.DESKPHONE) {
      this.copyDeskphoneButtonClicked.emit({ tileState, index });
    }
  }
}
